import Tag from "./Tag"

const PivotTag = () => {
  return (
    <Tag variant="invisible">pivot</Tag>
  )
}

export default PivotTag;